import { LegalAdAuctionDTO } from "../DTO/legalAdAuctionDTO";
import { Address } from "./address";

export class LegalAdAuction{

    public auctionId!:number;
    public void:boolean = false;
    public voidAt?:Date;
    public voidByUser?:string;
    public voidReason?:string;
    public auctionIsLive:boolean = false;
    public auctionType?:number;
    public auctionStatus?:number;
    public scheduleSeqNo?:number;
    public auctionStarting?:Date;
    public auctionEnding?:Date;
    public propertyId!:number;
    public propertyHeader?:string;
    public propertyAddress?:Address;
    public fileNo?:string;
    public caseNo?:string;
    public clientFileNo?:string;
    public attorneyFileNo?:string;
    public imageReference?:string;

    constructor(){
    }

    public static mapToDTO(param:LegalAdAuction) : LegalAdAuctionDTO{
        
        let dto = new LegalAdAuctionDTO();
        try
        {
            dto.auctionId = param.auctionId;
            dto.void = param.void;
            dto.voidAt = param.voidAt;
            dto.voidByUser = param.voidByUser;
            dto.voidReason = param.voidReason;
            dto.auctionIsLive = param.auctionIsLive;
            dto.auctionType = param.auctionType
            dto.auctionStatus = param.auctionStatus;
            dto.scheduleSeqNo = param.scheduleSeqNo;
            dto.auctionStarting = param.auctionStarting;
            dto.auctionEnding = param.auctionEnding;
            dto.propertyId = param.propertyId;
            dto.propertyHeader = param.propertyHeader;
            dto.propertyAddress = param.propertyAddress;
            dto.fileNo = param.fileNo;
            dto.caseNo = param.caseNo;
            dto.clientFileNo = param.clientFileNo;
            dto.attorneyFileNo = param.attorneyFileNo;
            dto.imageReference = param.imageReference;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:LegalAdAuctionDTO) : LegalAdAuction
    {
        
        let obj = new LegalAdAuction();
        try
        {
            obj.auctionId = param.auctionId;
            obj.void = param.void;
            if(param.voidAt) obj.voidAt = new Date(param.voidAt);
            obj.voidByUser = param.voidByUser;
            obj.voidReason = param.voidReason;
            obj.auctionIsLive = param.auctionIsLive;
            obj.auctionType = param.auctionType
            obj.auctionStatus = param.auctionStatus;
            obj.scheduleSeqNo = param.scheduleSeqNo;
            if(param.auctionStarting) obj.auctionStarting = new Date(param.auctionStarting);
            if(param.auctionEnding) obj.auctionEnding = new Date(param.auctionEnding);
            obj.propertyId = param.propertyId;
            obj.propertyHeader = param.propertyHeader;
            obj.propertyAddress = param.propertyAddress;
            obj.fileNo = param.fileNo;
            obj.caseNo = param.caseNo;
            obj.clientFileNo = param.clientFileNo;
            obj.attorneyFileNo = param.attorneyFileNo;
            obj.imageReference = param.imageReference;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}